import type { FireIconProps } from './types';

export default function DeficiencyFlag({ size = 24, color = 'currentColor', strokeWidth = 2, className, ...props }: FireIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      className={className} {...props}>
      {/* Flag pole */}
      <line x1="5" y1="2" x2="5" y2="22" />
      {/* Flag */}
      <path d="M5 3h14l-3 4 3 4H5" />
      {/* X mark on flag */}
      <line x1="10" y1="5" x2="14" y2="9" />
      <line x1="14" y1="5" x2="10" y2="9" />
    </svg>
  );
}
